import { useEffect, useState } from "react";
import { Modal as ReactModal } from "react-responsive-modal";
import { getUserId } from "../../common_utilities";
import { DMF_NOMINEELIST_API_URL } from "../../constants";
import axios from "axios";
import commonEncode from "../../commonEncode";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

const InfoStrip = () => {

    const location = useLocation();
    const loggedIn = useSelector((state) => state.loggedIn);

    const allowedPaths = [
        "/web/direct-mutual-fund/profile/dashboard/Nominee"
    ];

    const currentPath = window.location.pathname;

    const [showStrip, setShowStrip] = useState(false);
    const [stripTxt, setStripTxt] = useState("");

    const getNomineeInfo = async () => {

        if (!Boolean(loggedIn)) return;

        var user_id = getUserId();

        try {

            var dynamicNomineeData = { "user_id": user_id, "is_direct": '1' }
            var data = commonEncode.encrypt(JSON.stringify(dynamicNomineeData))

            var config = {
                method: "post",
                url: DMF_NOMINEELIST_API_URL,
                data: data,
            };

            var res = await axios(config);
            var response = JSON.parse(commonEncode.decrypt(res.data));

            if (response.error_code == 100) {
                if (response?.data[0]?.is_nominee_details_pending && !allowedPaths.includes(currentPath)) {
                    setShowStrip(true);
                    setStripTxt(response?.data[0]?.header_strip_message ?? '')
                } else {
                    setShowStrip(false);
                }
            }

            console.log('InfoStrip nominee response', JSON.parse(response));

        } catch (e) {

        }
    };

    useEffect(() => {
        getNomineeInfo();
    }, [loggedIn, location.pathname])

    useEffect(() => {
        console.log('location.pathname', location.pathname)
    }, [location.pathname])

    return (
        <>
            {
                showStrip && <div style={{ width: '100%', padding: '0.5rem 0.6rem', backgroundColor: '#042b62', color: 'white', textAlign: 'center', }}>
                    {stripTxt}&nbsp;&nbsp;
                    <span >
                        <Link
                            to={
                                process.env.PUBLIC_URL +
                                "/direct-mutual-fund/profile/dashboard/Nominee"
                            }
                            style={{ color: '#f68638', textDecorationL: 'none' }}
                        >Proceed</Link>
                    </span>

                </div>
            }
        </>
    )
}

export default InfoStrip